'use client'

import ViewIntersection from '@app/components/analytics/view-intersection/view-intersection'
import {ReactNode} from 'react'
import {HomePageSections} from './types'
import {LayoutEvent} from '@app/[lang]/(common-header-footer)/(home)/events'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

type Props = {
  children: ReactNode
  layout: HomePageSections | string
  order?: number
  className?: string
}

const SectionAnalyticsWrapperClient = ({children, layout, order, className}: Props) => {
  return (
    <ViewIntersection
      onVisible={() => {
        triggerAnalytics(LayoutEvent.Shown, {
          layout,
          order,
        }).sendAll()
      }}
      className={className}
    >
      {children}
    </ViewIntersection>
  )
}

export default SectionAnalyticsWrapperClient
